module.exports = __webpack_public_path__ + "static/media/xml.fb9ae02c.svg";